export default __webpack_public_path__ + "images/logo-xcritical-crm.png";